<template>
    <PanelPage>
        <template v-slot:title>
            <SmartBreadcrumbs
                :pages="[
                    {
                        name: $t('messages.attendance_report'),
                        href: meta.links.index,
                    },
                    {
                        name: group.name,
                        href: null,
                    },
                ]"
            />
        </template>

        <DropdownButton>
            <template v-slot:content>
                <a
                    :href="meta.links.group_attendance_show"
                    class="block px-4 py-2 text-sm leading-5 text-gray-700 hover:bg-gray-100 hover:text-gray-900 focus:outline-none focus:bg-gray-100 focus:text-gray-900"
                    role="menuitem"
                >
                    {{ $t('messages.group_attendance_review') }}
                </a>
                <a
                    :href="meta.links.absenteeism_index"
                    class="block px-4 py-2 text-sm leading-5 text-gray-700 hover:bg-gray-100 hover:text-gray-900 focus:outline-none focus:bg-gray-100 focus:text-gray-900"
                    role="menuitem"
                >
                    {{ $t('messages.absenteeism') }}
                </a>
            </template>
        </DropdownButton>

        <div v-if="months.length === 0" class="flex flex-col mt-5">
            <EmptyState picture />
        </div>
        <div v-else>
            <div class="mt-1" v-for="month in months" :key="month.number">
                <AppButton :href="month.url" desired-action target="_blank">
                    {{ month.name }}
                </AppButton>
            </div>
        </div>

        <hr class="my-2" />

        <div v-for="link in links" :key="link.url" class="mt-1">
            <AppButton :href="link.url" desired-action target="_blank">
                {{ link.display_name }}
            </AppButton>
        </div>
    </PanelPage>
</template>

<script>
import Layout from '@/Shared/Layout.vue';
import PanelPage from '@/Shared/PanelPage.vue';
import AppButton from '@/components/AppButton.vue';
import EmptyState from '@/components/EmptyState.vue';
import DropdownButton from '@/components/DropdownButton.vue';

export default {
    components: {
        DropdownButton,
        PanelPage,
        AppButton,
        EmptyState,
    },
    layout: Layout,
    name: 'Show',
    props: ['meta', 'months', 'group', 'links'],
};
</script>
